export interface ApiSendAdviceRequest {
    type: string;
    product: string;
    comment: string
}

export interface ApiSendAdviceResponse {}

export const SendAdvice = Symbol('SendAdvice');

export interface SendAdvice {
    sendAdvice(data: ApiSendAdviceRequest): Promise<ApiSendAdviceResponse>;
}